<template>
  <!-- <component v-bind:is="$store.state.user ? 'LayoutApp' : 'LayoutAuth'">
    <router-view></router-view>
  </component> -->
  <router-view></router-view>
</template>
<script>
// const LayoutApp = () => import(/* webpackChunkName: "layout-app" */ "./layouts/App");
// const LayoutAuth = () => import(/* webpackChunkName: "layout-auth" */ "./layouts/Auth");

export default {
  components: {
    // LayoutApp,
    // LayoutAuth,
  },
  mounted() {
    const vm = this;

    vm.$store.subscribe((mutation, state) => {
      if (mutation.type == "setUser") {
        if (state.user) {
          vm.axios.defaults.headers.common["Authorization"] = `Bearer ${state.user.token}`;
        } else {
          delete vm.axios.defaults.headers.common["Authorization"];
        }
      }
    });

    function windowOnResize() {
      vm.$store.commit("window/height", window.innerHeight);
      vm.$store.commit("window/width", window.innerWidth);
    }

    window.onresize = windowOnResize;
    windowOnResize();
  },
};
</script>
